import { CustomerType } from '@api/generated/graphql';
import addressFormValidationSchema from '@components/forms/components/AddressFormManager/components/AddressForm/validations';
import contactMethodsFormValidationSchema from '@components/forms/components/ContactMethodForm/validations';
import { string, z } from 'zod';
import strings from './strings';

// when the payee is 'customer', no additional billing information is required
const billingValidationForCustomerPayeeSchema = z.object({
  payee: z.literal('customer'),
});

// when the payee is 'billingCustomer', validate the billing information
const billingValidationForBillingCustomerPayeeSchema = z.object({
  payee: z.literal('billingCustomer'),
  billingCustomer: z.object({
    name: string().min(1, strings.errors.name),
    address: addressFormValidationSchema,
    contacts: contactMethodsFormValidationSchema,
  }),
});

// discriminates the payee field to determine which billing validation schema to use
const conditionalBillingValidationSchema = z.discriminatedUnion('payee', [
  billingValidationForCustomerPayeeSchema,
  billingValidationForBillingCustomerPayeeSchema,
]);

// validates the customer object
const customerValidationSchema = z.object({
  customer: z.object({
    name: string().min(1, strings.errors.locationName),
    address: addressFormValidationSchema,
    contacts: contactMethodsFormValidationSchema,
  }),
  type: z.enum([CustomerType.Commercial, CustomerType.Residential]),
  // locations: z.array(),
});

// useful type for testing
export type CreateCustomerValidationType = z.TypeOf<
  typeof createCustomerValidationSchema
>;

// combines the customer and billing validation schemas into one schema
export const createCustomerValidationSchema = z.intersection(
  customerValidationSchema,
  conditionalBillingValidationSchema,
);
